import React from "react";
import * as Popover from "@radix-ui/react-popover";
import { Button, Text } from "@origo/sp-lib";
import styled from "styled-components";
import { TurbineOptions } from "../context/types";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) =>
    props.theme.colors.componentBackgroundActive.primary};
  border-radius: ${(props) => props.theme.borderRadius.medium};
  padding: ${(props) => props.theme.spacing.heavy};
  row-gap: ${(props) => props.theme.spacing.medium};
  box-shadow: ${(props) => props.theme.shadow.boxShadow};
  width: 26rem;
`;

type TurbineSettingsConfirmationProps = {
  turbineOption: TurbineOptions;
  turbineValue: any;
  open: boolean;
  onClick?: (isConfirmed: boolean) => unknown;
};

export default function TurbineSettingsConfirmation({
  open,
  onClick,
  turbineOption,
  turbineValue,
}: TurbineSettingsConfirmationProps) {
  const renderContent = () => {
    switch (turbineOption) {
      case TurbineOptions.turbineStatus:
        return (
          <div>
            <Text size="md">
              Are you sure you want to {turbineValue} the turbine?
            </Text>
            <Text size="sm" className="p-2">
              This will affect production on this unit.
            </Text>
          </div>
        );

      case TurbineOptions.personnelStatus:
        return (
          <div>
            <Text size="md">
              Are you sure you want to {turbineValue} personnel for this
              turbine?
            </Text>
            <Text size="sm" className="p-2">
              This will update the personnel settings for this turbine on all
              views.
            </Text>
          </div>
        );

      case TurbineOptions.interlockStatus:
        return (
          <div>
            <Text size="md">
              Are you sure you want to {turbineValue} this turbine?
            </Text>
            <Text size="sm" className="p-2">
              Others will not be able to make changes to this turbine while it
              is in interlock mode.
            </Text>
          </div>
        );

      default:
        return null;
    }
  };
  return (
    <Popover.Root open={open}>
      <Popover.Trigger />
      <Popover.Portal>
        <Popover.Content
          side="top"
          align="end"
          alignOffset={-100}
          sideOffset={-100}
        >
          <Container>
            {renderContent()}

            <div className="flex gap-2 justify-center mt-4 bg-red-200">
              <Button onClick={() => onClick?.(true)}>Confirm</Button>
              <Button onClick={() => onClick?.(false)}>Cancel</Button>
            </div>
          </Container>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
